module.exports = __webpack_public_path__ + "static/media/janet_morrison.76cc7f17.pdf";